export function getLocalStorageData(key: string) {
  try {
    const serializedData = localStorage.getItem(key);
    if (!serializedData) return undefined;
    return JSON.parse(serializedData);
  } catch (e) {
    return undefined;
  }
}

export async function setLocalStorageData(key: string, data: any) {
  try {
    const serializedData = JSON.stringify(data);
    localStorage.setItem(key, serializedData);
  } catch (e) {
    console.error("Failed to set data to local storage with key of: " + key);
    // Ignore
  }
}
